import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Form, Input, Typography } from "antd";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

export const DetailFinanceCostDrawer: FC = () => {
    const { t } = usePaldockTranslation("drawers.detail-finance-cost");
    const { t: tC } = usePaldockTranslation("common");
    const id = DrawerId.DetailFinanceCost;

    return (
        <Drawer
            drawerId={id}
            title={<DrawerTitle mainTitle={t("title")} subTitles={["TODO - Affiliate Name"]} />}
            extraButtons={
                <Button size={"large"} type={"primary"}>
                    {tC("save")}
                </Button>
            }
        >
            <div className={"bg-gray-100 rounded-lg border-dashed border"}>
                <Form layout="vertical">
                    <div className="grid gap-x-4 p-4 bg-white m-3">
                        <Flex justify={"space-between"} gap={"small"} className="col-span-3 w-full">
                            <Typography.Title level={4}>{t("title")} ({t("fields.id_label")})</Typography.Title>
                            <Button type="primary" icon={<DeleteOutlined />} />
                        </Flex>

                        <div className="grid rounded-lg grid-cols-3 gap-x-4 col-span-3">
                            <Form.Item name="firstName" label={t("fields.country")}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="lastName" label={t("fields.category")}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="username" label={t("fields.offer")}>
                                <Input />
                            </Form.Item>

                            <Form.Item name="jmeno" label={t("fields.date")}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="jmeno" label={t("fields.origin_date")}>
                                <Input addonBefore="+420" />
                            </Form.Item>
                            <Form.Item name="jmeno" label={t("fields.type")}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="jmeno" label={t("fields.user")}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="jmeno" label={t("fields.type")}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="jmeno" label={t("fields.amount")}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="jmeno" label={t("fields.cost_id")}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="jmeno" label={t("fields.external_id")}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="jmeno" label={t("fields.conversion_id")}>
                                <Input />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="rounded-lg cursor-pointer bg-white m-3 p-12">
                        <Flex justify={"center"} align={"center"} gap={"middle"} className={"text-xlg"}>
                            <PlusOutlined /> {tC("add")}
                        </Flex>
                    </div>
                </Form>
            </div>
        </Drawer>
    );
};
